import React, { useEffect, useState } from "react";
import {
  AppBar,
  Menu,
  MenuItem,
  Tabs,
  Tab,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link, Outlet } from "react-router-dom";
import "../Styles/Navbar.css";
import logo from "../Images/LogoUK.jpg";
// import iraq from "../Images/iraq.png";
// import Kurdistan from "../Images/kurdstan.png";
// import English from "../Images/united-kingdom.png";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DrawerComp from "./Drawer";
import i18n from "../../i18n";

import Cookies from "js-cookie";

const Navbar = () => {
  const [value, setValue] = useState(0);
  // const [anchorElLang, setAnchorElLang] = useState(null);
  // const [anchorElBranches, setAnchorElBranches] = useState(null);
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  // eslint-disable-next-line no-unused-vars
  const [language, setLanguage] = useState("");
  const [showNavbar, setShowNavbar] = useState(true);

  // const onChangeLang = (selectedLang) => {
  //   setLanguage(selectedLang);
  //   i18n.changeLanguage(selectedLang);
  //   Cookies.set("language", selectedLang);
  // };

  useEffect(() => {
    const savedLang = Cookies.get("language");
    if (savedLang) {
      setLanguage(savedLang);
      i18n.changeLanguage(savedLang);
    }
  }, []);

  // const handleLanguageClick = (event) => {
  //   setAnchorElLang(event.currentTarget);
  // };

  // const handleLanguageClose = () => {
  //   setAnchorElLang(null);
  // };

  // const handleBranchesClick = (event) => {
  //   setAnchorElBranches(event.currentTarget);
  // };

  // const handleBranchesClose = () => {
  //   setAnchorElBranches(null);
  // };

  const TabLabelWithIcon = ({ label }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      {label} <ArrowDropDownIcon fontSize="large" />
    </div>
  );

  // Handlers for Services menu
  const [anchorElServices, setAnchorElServices] = useState(null);
  const handleServicesClick = (event) => {
    setAnchorElServices(event.currentTarget);
  };
  const handleServicesClose = () => {
    setAnchorElServices(null);
  };

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setShowNavbar(false); // Hide Navbar on scroll down
      } else {
        setShowNavbar(true); // Show Navbar on scroll up
      }
      lastScrollY = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <React.Fragment>
      <AppBar
        sx={{
          backgroundColor: "white",
          color: "black",
          fontWeight: "bold",
          fontSize: "16px",
          transition: "top 0.3s", // Smooth hide/show
          top: showNavbar ? "0" : "-80px", // Adjust height based on Navbar height
          position: "fixed", // Fix position at the top
        }}
      >
        <Toolbar>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              fontSize: "20px",
              fontWeight: "bold",
            }}
          >
            <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
              <div style={{ display: "inline-flex", alignItems: "center" }}>
                <img
                  src={logo}
                  alt="Logo"
                  height={60}
                  width={60}
                  style={{ borderRadius: "5px", objectFit: "cover" }}
                />
                <span style={{ marginRight: "4px" }}></span>
                <div className="TextNavbar">UK TO MARS LTD</div>
              </div>
            </Link>
          </div>
          {isMatch ? (
            <DrawerComp />
          ) : (
            <>
              <Tabs
                sx={{ marginLeft: "auto" }}
                indicatorColor="link"
                textColor="inherit"
                value={value}
                onChange={(e, value) => setValue(value)}
              >
                {/* <Tab
                  component={Link}
                  to="/Payment"
                  label={t("priceList")}
                  iconPosition="start"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                /> */}

                <Tab
                  label={<TabLabelWithIcon label={"Services"} />}
                  iconPosition="start"
                  onClick={handleServicesClick}
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                />

                {/* <Tab
                  label={<TabLabelWithIcon label={t("offices")} />}
                  iconPosition="start"
                  onClick={handleBranchesClick}
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                /> */}
                <Tab
                  component={Link}
                  to="/AboutUs"
                  label={"About Us"}
                  iconPosition="start"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                />
                {/* <Tab
                  label={<TabLabelWithIcon label={t("language")} />}
                  iconPosition="start"
                  onClick={handleLanguageClick}
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                /> */}
                {/* <Menu
                  anchorEl={anchorElBranches}
                  open={Boolean(anchorElBranches)}
                  onClose={handleBranchesClose}
                >
                  <MenuItem
                    component={Link}
                    to="/UKOffices"
                    onClick={handleBranchesClose}
                  >
                    {t("ukOffices")}
                  </MenuItem>
                  <MenuItem
                    component={Link}
                    to="/IraqOffice"
                    onClick={handleBranchesClose}
                  >
                    {t("iraqOffice")}
                  </MenuItem>
                </Menu> */}
                <Menu
                  anchorEl={anchorElServices}
                  open={Boolean(anchorElServices)}
                  onClose={handleServicesClose}
                >
                  {/* <MenuItem
                    component={Link}
                    to="/RoadTransport"
                    onClick={handleServicesClose}
                  >
                    {t("roadTransport2")}
                  </MenuItem> */}
                  <MenuItem
                    component={Link}
                    to="/Wholesale_Distribution"
                    onClick={handleServicesClose}
                  >
                    Wholesale Distribution
                    {/* {t("wholesaleForBusiness2")} */}
                  </MenuItem>
                  <MenuItem
                    component={Link}
                    to="/Export_Services"
                    onClick={handleServicesClose}
                  >
                    Export Services
                    {/* {t("youShopWeDeliver")} */}
                  </MenuItem>

                  {/* <MenuItem
                    component={Link}
                    to="/International_Transportation"
                    onClick={handleServicesClose}
                  >
                    International Transportation
                  
                  </MenuItem> */}
                  <MenuItem
                    component={Link}
                    to="/Logistics_Storage_Solutions"
                    onClick={handleServicesClose}
                  >
                    Logistics & Storage Solutions
                    {/* {t("localDelivery2")} */}
                  </MenuItem>
                  <MenuItem
                    component={Link}
                    to="/Customs_Clearance"
                    onClick={handleServicesClose}
                  >
                    Customs Clearance
                    {/* {t("customsClearance2")} */}
                  </MenuItem>
                </Menu>
                {/* <Menu
                  anchorEl={anchorElLang}
                  open={Boolean(anchorElLang)}
                  onClose={handleLanguageClose}
                >
                  <MenuItem
                    onClick={() => {
                      onChangeLang("en");
                      handleLanguageClose();
                    }}
                  >
                    <ListItemIcon>
                      <img src={English} alt="English" height={25} width={25} />
                    </ListItemIcon>
                    {t("english")}
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      onChangeLang("ku");
                      handleLanguageClose();
                    }}
                  >
                    <ListItemIcon>
                      <img
                        src={Kurdistan}
                        alt="Kurdistan Flag"
                        height={25}
                        width={25}
                      />
                    </ListItemIcon>
                    {t("kurdish")}
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      onChangeLang("ar");
                      handleLanguageClose();
                    }}
                  >
                    <ListItemIcon>
                      <img src={iraq} alt="Iraq Flag" height={30} width={30} />
                    </ListItemIcon>
                    {t("arabic")}
                  </MenuItem>
                </Menu> */}
              </Tabs>
            </>
          )}
        </Toolbar>
      </AppBar>
      <Outlet />
    </React.Fragment>
  );
};

export default Navbar;
